const FirstIcodeItem = (id, partyDetails, item) => {
  return {
    id: id,
    VOUCHER_PRINT_PREFIX: "",
    DOC_NO: partyDetails.DOC_NO,
    VOUCHER_TYPE: partyDetails.VOUCHER_TYPE,
    DATE: partyDetails.DATE,
    NARRATION: partyDetails.NARRATION,
    ACCOUNT_NO: item.ACCOUNT_NO,
    ACCOUNT_NAME: item.ACCOUNT_NAME,
    UNDER_GROUP_CODE: item.UNDER_GROUP_CODE ? item.UNDER_GROUP_CODE : "",
    UNDER_GROUP: item.UNDER_GROUP,
    ROOT_GROUP: item.ROOT_GROUP,
    BALANCE_SHEET_CLASS: item.BALANCE_SHEET_CLASS
      ? item.BALANCE_SHEET_CLASS
      : "",
    TRANSACTION_TYPE: item.DEBIT > 0 ? "D" : "C",
    BALANCE_SHEET_SIDE: item.BALANCE_SHEET_SIDE ? item.BALANCE_SHEET_SIDE : "",
    DEBIT: item.DEBIT,
    CREDIT: item.CREDIT,
    TRANSACTION_TYPE: "",
    CURRENT_BALANCE2: item.CURRENT_BALANCE
      ? Number(item.CURRENT_BALANCE) + Number(item.DEBIT) - Number(item.CREDIT)
      : 0,
    CURRENT_BALANCE: item.CURRENT_BALANCE,
    CURRENT_BALANCE_TYPE: item.CURRENT_BALANCE_TYPE
      ? item.CURRENT_BALANCE_TYPE
      : "Dr",
    REMARKS: partyDetails.REMARKS,
    LEDGER_NAME: "",
    BANK_NAME: "",
    FAVOURING_NAME: "",
    FAVOURING_CODE: "0",
    CLEARANCE_DATE: "",
    INSTRUMENT_NUMBER: "",
    INSTRUMENT_DATE: "",
    TYPE_OF_TRANSACTION: "",
    SALE_BILL_NO: "",
    SALE_ENTRY_CODE: "",
    PURCHASE_BILL_NO: "",
    ENTRY_LINK: "",

    PURCHASE_ENTRY_CODE: "",
    MOBILE: item.MOBILE,
  };
};

export default FirstIcodeItem;
